export default "__VITE_ASSET__B1Kj$AJI__"